import React, { useEffect, useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { listBundles } from "@/lib/api";
import BundleCard from "@/components/BundleCard";

export default function Bundles() {
  const { t, lang } = useLanguage();
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listBundles()
      .then(setBundles)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="bg-[#F9F8F6] border-b border-[#E5E2DC]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-px bg-[#D97B66]"></span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#6B726C] font-medium">
              {t("bundles_eyebrow")}
            </span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl tracking-tight font-light text-[#2C302E]">
            {t("bundles_title")}
          </h1>
          <p className="mt-4 text-[#6B726C] text-base md:text-lg max-w-2xl">
            {t("bundles_sub")}
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
        {loading ? (
          <div className="text-[#6B726C] text-center py-24">{t("loading")}</div>
        ) : bundles.length === 0 ? (
          <div className="text-[#6B726C] text-center py-24">
            {lang === "en" ? "No bundles available." : "Ingen pakker tilgjengelig."}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {bundles.map((b, i) => (
              <BundleCard key={b.id} bundle={b} idx={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
